import TagManager from "react-gtm-module";

export const gtm = (tagManagerArgs) => {
	if (window.location.hostname !== 'localhost') {
		TagManager.initialize(tagManagerArgs);
	}else {
        //console.log("tagManagerArgs", tagManagerArgs);
    }
}
